<template>
  <div class="modal__error bg-white" style="z-index: 9699; width: 54vw;" v-if="visible">
    <div class="d-flex justify-content-between">
      <p>مستندات</p>
      <p @click="close">❌</p>
    </div>
    <hr>
    <div class="row justify-content-between align-items-end">
      <div class="col-5">
        <div v-if="status_insert" class="d-flex flex-column">
          <label class="required">عنوان مستندات پیوست</label>
          <input v-model="newDocument.title" type="text" class="form-control" />
        </div>
      </div>
      <div class="col-5">
        <div v-if="status_insert" class="d-flex flex-column">
          <label class="required">فایل پیوست</label>
          <input type="file" class="form-control d-block" ref="fileInput" @change="handleFileChange" />
        </div>
      </div>
      <div class="col-2">
        <center v-if="status_insert">
          <button @click.prevent="addDocument" class="btn btn-primary btn-submit-1">افزودن</button>
        </center>
      </div>
    </div>
    <div v-if="uploadProgress > 0" class="progress my-2">
      <div
          class="progress-bar progress-bar-striped progress-bar-animated"
          role="progressbar"
          :style="{ width: uploadProgress + '%' }"
      >
        {{ uploadProgress }}%
      </div>
    </div>
    <hr v-if="status_insert" class="my-3 w-100" />
    <table class="table table-striped bg-white">
      <thead>
      <tr>
        <th><strong>عنوان مستند</strong></th>
        <th><strong>فایل مستند</strong></th>
        <th v-if="status_insert" style="width: 1vw;">عملیات</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in documents" :key="index">
        <td>{{ item.file_name }}</td>
        <td>
          <a :href="`${this.download_url}/${item.src}`" target="_blank">مشاهده</a>
        </td>
        <td v-if="status_insert">
          <a @click.prevent="deleteItemModal(item.id)" href="#">
            <img class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete" />
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="remove_modal" style="z-index: 999999999999999; top: 55%;">
    <div>
      <p>حذف</p>
      <p @click="remove_modal=!remove_modal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="remove_modal=!remove_modal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteDocument(item_id)">تایید</button>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  props: {
    status_insert: {
      type: Boolean,
      required: true,
    }, visible: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      documents: [],
      newDocument: {
        title: "",
        file: null,
      },
      uploadProgress: 0,
      item_id: null,
      remove_modal: false,
    };
  },

  methods: {
    close() {
      this.$emit("close");
    },
    handleFileChange(event) {
      this.newDocument.file = event.target.files[0];
    },
    async addDocument() {
      if (!this.newDocument.title || !this.newDocument.file) {
        toast.error("عنوان و فایل نمی‌توانند خالی باشند");
        return;
      }

      const formData = new FormData();
      formData.append("title", this.newDocument.title);
      formData.append("file", this.newDocument.file);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      try {
        const response = await fetch(`${this.base_url}/impact-assessment/store_photographer_doc/${this.id}`, {
          method: "POST",
          body: formData,
          headers: myHeaders,
        });
        const data = await response.json();

        if (data.error) {
          toast.error(data.error);
        } else {
          toast.success(data.message);
          this.documents.push(data.document);
          this.newDocument.title = "";
          this.$refs.fileInput.value = null;
          this.uploadProgress = 0;
        }
      } catch (error) {
        toast.error("خطا در ارسال درخواست");
        this.uploadProgress = 0;
      }
    },
    deleteItemModal(id){
      this.item_id = id
      this.remove_modal = true
    },
    async deleteDocument(documentId) {


      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      try {
        const response = await fetch(`${this.base_url}/impact-assessment/delete_photographer_doc/${this.item_id}`, {
          method: "DELETE",
          headers: myHeaders,
        });
        const data = await response.json();

        if (data.error) {
          toast.error(data.error);
        } else {
          toast.success(data.message);
          this.remove_modal = false
          this.documents = this.documents.filter((doc) => doc.id !== documentId);
        }
      } catch (error) {
        toast.error("خطا در حذف مستند");
      }
    },
    async fetchDocuments() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      try {
        const response = await fetch(`${this.base_url}/impact-assessment/all_photographer_doc/${this.id}`, {
          headers: myHeaders,
        });
        const data = await response.json();

        if (data.documents) {
          this.documents = data.documents;
        }
      } catch (error) {
        toast.error("خطا در بارگذاری مستندات");
      }
    },
  },
  mounted() {
    this.fetchDocuments();
  },
};

</script>

<style scoped>
.progress-bar {
  background-color: #007bff;
}
</style>
